import { AuthStore } from "@infrastructure/stores/auth.store";
import { HandleableError } from "@shared/utils/errors/handleableError";

export class ApiError extends HandleableError {
  constructor(
    message?: string,
    description?: string,
    public code?: number,
  ) {
    super(message ?? "General API error", description);

    // При 401 ошибка уже обработана в apiErrorHandler.ts
    // Там установлен статус "не авторизирован" и запущена переавторизация
    if (code === 401) {
      this.handle();
    }
  }
}

export class UnexpectedResponseError extends ApiError {
  constructor(
    public readonly url: string,
    public readonly expected: unknown,
    public readonly garbage: unknown,
  ) {
    console.warn("Unexpected response came from server", {
      url,
      expected,
      garbage,
    });
    super("Сервер вернул непредвиденный ответ");
  }
}

export class AbortError extends ApiError {
  constructor() {
    super("AbortError", "The operation was aborted");
    this.handle();
  }
}

export class TimeoutError extends ApiError {
  constructor(url: string, timeout: number) {
    super(
      "Превышено время ожидания",
      `Запрос к ${url} не был выполнен в течение ${timeout / 1000} секунд`,
    );
    this.handle();
  }
}

